import { DeleteProfileProposalAPIType } from "shared/types/UserInfo"

export function deleteProfileProposalSerializer(
  data: unknown,
  headers: Headers
) {
  headers.set("Content-Type", "application/json")

  const basePayload = {
    jsonapi: {
      version: "1.0"
    },
    data: { type: DeleteProfileProposalAPIType }
  }

  if (typeof data === "object" && data !== null && "securityCode" in data) {
    return {
      body: JSON.stringify({
        ...basePayload,
        data: {
          ...basePayload.data,
          id: data.securityCode,
          attributes: {
            securityCode: data.securityCode
          }
        }
      }),
      headers
    }
  }

  return {
    body: JSON.stringify(basePayload),
    headers
  }
}
